let _registration = { 
    IsTermsAccepted: false,
    Persons: [],
    Status: "Active",
    Location: {
        Text: null
    }
};

export default _registration;